export const durationValues = [
  { name: "Last Week", value: "last_week" },
  { name: "Last Month", value: "last_month" },
];

export const filterValues = [
  { name: "List View", value: "list_view" },
  { name: "State", value: "state" },
  { name: "Organization", value: "organization" },
];

export const allStateList = [
  {
    name: "Andhra Pradesh",
    value: "Andhra Pradesh",
    className: "andhra-pradesh",
  },
  {
    name: "Arunachal Pradesh",
    value: "Arunachal Pradesh",
    className: "arunachal-pradesh",
  },
  { name: "Assam", value: "Assam", className: "assam" },
  { name: "Bihar", value: "Bihar", className: "bihar" },
  { name: "Chhattisgarh", value: "Chhattisgarh", className: "chhattisgarh" },
  { name: "Chandigarh", value: "Chandigarh", className: "chandigarh" },
  { name: "Delhi", value: "Delhi", className: "delhi" },
  { name: "Goa", value: "Goa", className: "goa" },
  { name: "Gujarat", value: "Gujarat", className: "gujarat" },
  { name: "Haryana", value: "Haryana", className: "haryana" },
  {
    name: "Himachal Pradesh",
    value: "Himachal Pradesh",
    className: "himachal",
  },
  { name: "Jammu and Kashmir", value: "Jammu and Kashmir", className: "jammu" },
  { name: "Jharkhand", value: "Jharkhand", className: "jharkhand" },
  { name: "Karnataka", value: "Karnataka", className: "karnataka" },
  { name: "Kerala", value: "Kerala", className: "kerala" },
  { name: "Ladakh", value: "Ladakh", className: "ladakh" },
  {
    name: "Madhya Pradesh",
    value: "Madhya Pradesh",
    className: "madhya-pradesh",
  },
  { name: "Maharashtra", value: "Maharashtra", className: "maharashtra" },
  { name: "Manipur", value: "Manipur", className: "manipur" },
  { name: "Meghalaya", value: "Meghalaya", className: "meghalaya" },
  { name: "Mizoram", value: "Mizoram", className: "mizoram" },
  { name: "Nagaland", value: "Nagaland", className: "nagaland" },
  { name: "Odisha", value: "Odisha", className: "odisha" },
  { name: "Punjab", value: "Punjab", className: "punjab" },
  { name: "Rajasthan", value: "Rajasthan", className: "rajasthan" },
  { name: "Sikkim", value: "Sikkim", className: "sikkim" },
  { name: "Tamil Nadu", value: "Tamil Nadu", className: "tamil-nadu" },
  { name: "Telangana", value: "Telangana", className: "telangana" },
  { name: "Tripura", value: "Tripura", className: "tripura" },
  { name: "Uttar Pradesh", value: "Uttar Pradesh", className: "uttar-pradesh" },
  { name: "Uttarakhand", value: "Uttarakhand", className: "uttarakhand" },
  { name: "West Bengal", value: "West Bengal", className: "west-bengal" },
];
